module.exports = __webpack_public_path__ + "static/media/hamburger_bottom_right.9e25ae01.png";